import { useState, useEffect } from 'react';

const usePatchCombinations = () => {
  const [combinations, setCombinations] = useState([]);
  const [patches, setPatches] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const WP_API_URL =
    process.env.REACT_APP_WORDPRESS_URL || 'http://localhost:8080';

  useEffect(() => {
    const fetchData = async () => {
      try {
        const combinationsResponse = await fetch(
          `${WP_API_URL}/wp-json/wp/v2/app-settings`
        );
        if (!combinationsResponse.ok)
          throw new Error('Failed to fetch combinations');
        const combinationsData = await combinationsResponse.json();

        const patchesResponse = await fetch(
          `${WP_API_URL}/wp-json/wp/v2/patch?per_page=100`
        );
        if (!patchesResponse.ok) throw new Error('Failed to fetch patches');
        const patchesData = await patchesResponse.json();

        setCombinations(combinationsData.icon_answer_combinations || []);
        setPatches(patchesData);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [WP_API_URL]);

  const getPatchForAnswers = (q1Answer, q2Answer) => {
    const matchingCombination = combinations.find(
      (combo) =>
        combo.question_1_answer_value === q1Answer &&
        combo.question_2_answer_value === q2Answer
    );

    if (
      matchingCombination?.patch_result &&
      matchingCombination.patch_result.length > 0
    ) {
      const patchId =
        matchingCombination.patch_result[0].ID ||
        matchingCombination.patch_result[0].id;

      const patch = patches.find((p) => p.id === patchId);

      if (patch) {
        return {
          id: patch.id,
          name: patch.title?.rendered || 'Unknown Patch',
          image: patch.acf?.patch_image?.url || patch.acf?.patch_image,
          file: patch.acf?.patch_file_name,
          description: patch.acf?.patch_description || '',
          slug: patch.slug
        };
      }
    }

    return null;
  };

  return {
    combinations,
    patches,
    loading,
    error,
    getPatchForAnswers
  };
};

export default usePatchCombinations;
